import { render, staticRenderFns } from "./gaopin.vue?vue&type=template&id=02384b9e&scoped=true"
import script from "./gaopin.vue?vue&type=script&lang=js"
export * from "./gaopin.vue?vue&type=script&lang=js"
import style0 from "./gaopin.vue?vue&type=style&index=0&id=02384b9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02384b9e",
  null
  
)

export default component.exports